import { Component, Inject } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components/lib/application/+state/application.facade';
import Env from '@ridango/core/env';

@Component({
    selector: 'gl-ticket-purchase-same-validity-confirmation-modal',
    templateUrl: './ticket-purchase-same-validity-confirmation.component.html',
    styleUrls: ['./ticket-purchase-same-validity-confirmation-modal.component.scss']
})
export class TicketPurchaseSameValidityConfirmationComponent {
    public assetsPath$ = this.applicationFacade.assetsPath$;
    constructor(
        private modalCtrl: ModalController,
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env
    ) {}

    continueWithSame() {
        this.modalCtrl.dismiss(true, 'confirm');
    }

    cancel() {
        this.modalCtrl.dismiss(false, 'cancel');
    }
}
